import React, { useMemo, useRef, useEffect } from "react";
import ConversationHeader from "../molecules/ConversationHeader";
import MessageComposer from "../molecules/MessageComposer";
import MessageBubble from "../atoms/MessageBubble";
import DaySeparator from "../atoms/DaySeparator";
import { INK_3, LINE } from "../../Bureau/bureauTokens";

function sameDay(a, b) {
  return new Date(a).toDateString() === new Date(b).toDateString();
}

function ConversationPane({ otherUser, messages, currentUserId, hasMore, onLoadOlder, onSend }) {
  const scrollRef = useRef(null);
  const prevLengthRef = useRef(0);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    // Ne scrolle en bas qu'à l'arrivée d'un nouveau message (pas quand on
    // vient de charger de l'historique plus ancien en haut du fil).
    if (messages.length > prevLengthRef.current) {
      el.scrollTop = el.scrollHeight;
    }
    prevLengthRef.current = messages.length;
  }, [messages]);

  const grouped = useMemo(() => {
    const groups = [];
    messages.forEach((m) => {
      const last = groups[groups.length - 1];
      if (last && sameDay(last.date, m.createdAt)) {
        last.items.push(m);
      } else {
        groups.push({ date: m.createdAt, items: [m] });
      }
    });
    return groups;
  }, [messages]);

  return (
    <div
      className="flex flex-col h-full min-h-0"
      style={{ background: "#fff", border: `1px solid ${LINE}`, borderRadius: 14 }}
    >
      <ConversationHeader otherUser={otherUser} />
      <div ref={scrollRef} className="flex-1 overflow-y-auto px-4 py-3 flex flex-col">
        {hasMore && (
          <button
            onClick={onLoadOlder}
            className="text-[11px] font-semibold self-center mb-2 flex-shrink-0"
            style={{ color: INK_3 }}
          >
            Charger les messages précédents
          </button>
        )}
        {grouped.map((group) => (
          <div key={group.date}>
            <DaySeparator date={group.date} />
            <div className="flex flex-col gap-1.5">
              {group.items.map((m) => (
                <MessageBubble
                  key={m.id}
                  body={m.body}
                  createdAt={m.createdAt}
                  outgoing={m.senderId === currentUserId}
                  attachmentUrl={m.attachmentUrl}
                  attachmentName={m.attachmentName}
                  attachmentType={m.attachmentType}
                  attachmentSize={m.attachmentSize}
                />
              ))}
            </div>
          </div>
        ))}
        {messages.length === 0 && (
          <div className="flex-1 flex items-center justify-center text-xs" style={{ color: INK_3 }}>
            Aucun message pour l'instant — dites bonjour !
          </div>
        )}
      </div>
      <MessageComposer onSend={onSend} />
    </div>
  );
}

export default ConversationPane;
